export const INVOICE_STATUS_FILTER_VALUE = {
  ALL: 'All',
  PROCESSING: 'PROCESSING',
  PENDING_DOCUMENTS_REVIEW: 'PendingDocumentsReview',
  PENDING_RATIFICATION: 'PendingRatification',
  PENDING_TRANSFER: 'PendingTransfer',
};

export const INVOICE_STATUS_FILTER_ALL_OPTION = {
  label: 'Todos',
  value: INVOICE_STATUS_FILTER_VALUE.ALL,
  key: 'All-statusFilter',
  filter: {
    status: [],
  },
};

export const INVOICE_STATUS_FILTER_DEFAULT_LABEL = 'Estado';

const INVOICE_OPERATION_STATES_OPTIONS = [
  INVOICE_STATUS_FILTER_ALL_OPTION,
  {
    label: 'Procesando cesión',
    value: INVOICE_STATUS_FILTER_VALUE.PROCESSING,
    key: 'Processing-statusFilter',
    filter: {
      status: ['Processing'],
    },
  },
  {
    label: 'Revisión documentos',
    value: INVOICE_STATUS_FILTER_VALUE.PENDING_DOCUMENTS_REVIEW,
    key: 'PendingDocumentsReview-statusFilter',
    filter: {
      status: ['PendingDocumentsReview'],
    },
  },
  {
    label: 'Por ratificar',
    value: INVOICE_STATUS_FILTER_VALUE.PENDING_RATIFICATION,
    key: 'PendingRatification-statusFilter',
    filter: {
      status: ['PendingRatification'],
    },
  },
  {
    label: 'En curse',
    value: INVOICE_STATUS_FILTER_VALUE.PENDING_TRANSFER,
    key: 'PendingTransfer-statusFilter',
    filter: {
      status: ['PendingTransfer'],
    },
  },
];

export default INVOICE_OPERATION_STATES_OPTIONS;
